import axios from "axios";
import React, {
    Component,
    useState,
    useEffect,
    useContext,
    lazy,
    Suspense,
} from "react";
import { Helmet } from "react-helmet";
import BitmediaAd from '../../../mission/bitmedia';
import AdSense from "react-adsense";
import { FaRegClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";
import Login_google from './.././../login';
import Buylink from './../../urlshorten_system/buy_link.jsx';
function Mode_partner() {
    const [nutxuly, setnutxuly] = useState("");
    const [link_partner, setlink_partner] = useState("/");
    const [buttonTextjop, setbuttonTextjop] = useState("");
    const [loading, setLoading] = useState(false);
    const [apikey, setapikey] = useState(false);
    const [hustmediavipro, sethustmediavipro] = useState("");
    function handleSubmit() {
        // Chuyển hướng sang trang web khác
        window.location.href = link_partner;
    };
    function laydulieu() {
        const myCookieValue = Cookies.get("apikey");
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");
        if (myCookieValue) {
            setapikey(myCookieValue);
        }
        if (hustmediavipro) {
            sethustmediavipro(hustmediavipro);
        }
        axios
            .get("https://hust.media/link/load_mode/mode_partner_start.php", {
                params: {
                    lienket: hustmediavipro,
                    apikey: myCookieValue,
                    code_item: code_item
                },
            })
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    }
    function testFunction(response) {
        setLoading(true);
        const info = response.data;
        const status = info.status;
        const message = info.message;
        const service_name = info.service_name;
        const order = info.order;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 1) {
            alert_success(message);
        }
        if (service_name) {
            setbuttonTextjop(service_name);
        }
        if (order) {
            setlink_partner(order);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }

    };
    useEffect(() => {
        laydulieu();
    }, []);
    return (
        <div>
            <div className="form-control">
                <div
                    style={{ textAlign: "center" }}
                    className="mt-0 justify-center items-center">
                    {apikey ? (<><Buylink hustmediavipro={hustmediavipro} /></>) : (<>
                        <div className="mb-1 ">
                            <div>Đăng nhập google để nhận link miễn phí</div>
                            <Login_google />
                        </div>
                        <div className="mb-1 ">Hoặc:</div>
                    </>)}
                    {loading == false ? (
                        <>
                            <div>
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                ></div>
                                <span>Đang tải dữ liệu</span>
                            </div>
                        </>
                    ) : (
                        loading == true && (
                            <>
                                <div className="mt-2 mx-auto max-w-md">
                                    <button
                                        // disabled={disabledbutton}
                                        onClick={handleSubmit}
                                        className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                                        <div className='flex items-center justify-between flex-1'>
                                            {nutxuly == 1 &&
                                                <div className="spinner-border" role="status">

                                                </div>}
                                            <span className='text-lg font-medium text-white'>
                                                {buttonTextjop} </span>
                                                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                        </div>
                                    </button>
                                </div>
                            </>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}

export default Mode_partner;